module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0006-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/introduction#intro",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("Introduction: People Live to Please Dogs")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter01#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("CHAPTER")])]), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f006-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tocca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter01#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "greyx"
  }, [_vm._v("HOW TO CHOOSE A HUMAN")])])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter01#ch01_lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("The Accommodating Personality")])])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter01#ch01_lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("Playfulness Test")])])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter01#ch01_lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("Wealth")])])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter01#ch01_lev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("Physical Resemblance")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("CHAPTER")])]), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f006-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tocca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "greyx"
  }, [_vm._v("MALE, FEMALE, OR BOTH?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch02_lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("The Human Male")])])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch02_lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("The Human Female")])])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch02_lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("The Human Couple")])])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch02_lev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("Same-Sex Couples")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("CHAPTER")])]), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f007-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tocca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "greyx"
  }, [_vm._v("BASIC TRAINING")])])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch03_lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("Incentive-Based Training")])])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch03_lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("The Conditioned Reflex")])])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch03_lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("Reverse Psychology")])])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch03_lev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("Physical Cues")])])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch03_lev5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("Keep It Simple")])])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch03_lev6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("Reading Human Cues")])])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch03_lev7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("Grooming")])])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch03_lev8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("Humans in Bed")])])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch03_lev9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("A Word about Cats")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("CHAPTER")])]), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f007-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tocca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "greyx"
  }, [_vm._v("DISCIPLINE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch04_lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("Communicating Disapproval")])])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch04_lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("Aversive Conditioning")])])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch04_lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("Genital Inhibition")])])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch04_lev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("Using Humans"), _c('span', {
    staticClass: "entity"
  }, [_vm._v("’")]), _vm._v(" Size Against Them")])])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch04_lev5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("Leash Training")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("CHAPTER")])]), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f007-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tocca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "greyx"
  }, [_vm._v("GETTING THE FOOD YOU WANT")])])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch05_lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("Nutrition and Flavor")])])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch05_lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("Table Food")])])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch05_lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("Problem People")])])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch05_lev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("Vegetarianism")])])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch05_lev5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("Fasting")])])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch05_lev6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("A Few Words on Vomit")])])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch05_lev7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("The Loose Stool")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("CHAPTER")])]), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f008-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tocca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "greyx"
  }, [_vm._v("ADVANCED TRAINING")])])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#ch06_lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("Throwing the Ball")])])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#ch06_lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("The Reluctant Thrower")])])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#ch06_lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("Chauffeurs")])])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#ch06_lev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("Hunting")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("CHAPTER")])]), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f008-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tocca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "greyx"
  }, [_vm._v("THE HUMAN PUP")])])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch07_lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("The Maternal Instinct")])])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch07_lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("Pretending to Like Them")])])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch07_lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("They Improve with Age")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("CHAPTER")])]), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f008-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tocca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "greyx"
  }, [_vm._v("WHEN THEY GET OLD")])])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#ch08_lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("Don"), _c('span', {
    staticClass: "entity"
  }, [_vm._v("’")]), _vm._v("t Feel Guilty")])])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#ch08_lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("What Comes Next")])])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#ch08_lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("Legal Issues")])])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#ch08_lev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "grey1"
  }, [_vm._v("Spiritual Considerations")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0